.dropdown-button {
  position: relative;
  display: flex;
  cursor: pointer;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 8px;
  padding: 0 12px;
}

.dropdown-button > span {
  max-width: calc(100% - 15px);
  color: initial;
}

.dropdown-button .caret {
  font-size: 30px;
}

.dropdown-button .caret {
  height: 100%;
  display: grid;
  place-items: center;
  transition: transform 0.5s;
  width: 15px;
}

.dropdown-button .caret span {
  height: 42px;
  display: flex;
  align-items: center;
}

.dropdown-button .caret.open {
  transform: rotate(180deg);
}

.dropdown-input-container {
  flex: 1;
  height: 100%;
  position: relative;
}

.placeholder {
  color: rgb(117, 117, 117);
  font-weight: 400;
  font-family: inherit;
}
